import { render, staticRenderFns } from "./TimeslotFeatures.vue?vue&type=template&id=591ed98e&scoped=true"
import script from "./TimeslotFeatures.vue?vue&type=script&lang=js"
export * from "./TimeslotFeatures.vue?vue&type=script&lang=js"
import style0 from "./TimeslotFeatures.vue?vue&type=style&index=0&id=591ed98e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591ed98e",
  null
  
)

export default component.exports